<template>
    <div class="dm-auth-wrapper">
        <div class="d-flex flex-sm-column justify-content-center">
            <div class="card shadow-sm bg-white">
                <div class="card-body">
                    <h4 class="text-center text-dark">
                        {{ translate("Login to bb-flow") }}
                    </h4>
                    <div class="mb-4" v-if="errors.length">
                        <div
                            class="alert alert-custom alert-light-danger p-4 mb-6"
                        >
                            <div class="alert-icon">
                                <i class="las la-exclamation-triangle"></i>
                            </div>
                            <div class="alert-text">
                                <div class="fw-bolder">
                                    {{
                                        translate(
                                            "Whoops! Something went wrong.",
                                        )
                                    }}
                                </div>
                                <ul class="p-0 m-0" style="list-style: none">
                                    <li>{{ errors }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <form
                        method="POST"
                        class="dm-parsley-validate-form"
                        id="dm-log-in-form"
                        @submit.prevent="validateAndSubmit()"
                    >
                        <div>
                            <label class="form-label" for="email">{{
                                translate("Email")
                            }}</label>
                            <input
                                class="form-control"
                                id="email"
                                type="email"
                                name="email"
                                required=""
                                :disabled="submitting"
                                autofocus=""
                                v-model="email"
                                @keyup="errors = ''"
                            />
                        </div>

                        <div class="mt-4">
                            <label class="form-label" for="password">{{
                                translate("Password")
                            }}</label>
                            <input
                                class="form-control"
                                id="password"
                                type="password"
                                name="password"
                                :disabled="submitting"
                                required=""
                                autocomplete="current-password"
                                v-model="password"
                                @keyup="errors = ''"
                            />
                        </div>
                        <!-- <div class="mt-3 checkbox-list">
							<label
								for="remember_me"
								class="checkbox"
							>
								<input
									id="remember_me"
									type="checkbox"
									class=""
									name="remember"
									:disabled="submitting"
									v-model="remember"
									@change="errors = ''"
								>
								<span></span>{{ translate("Remember me") }}
							</label>
						</div> -->
                        <div
                            class="d-flex align-content-center justify-content-between mt-4"
                        >
                            <div class="d-flex flex-wrap">
                                <div class="w-100">
                                    <a
                                        class="d-inline-block text-dark text-decoration-underline"
                                        href=""
                                        @click.prevent="$emit('switchForm')"
                                        >{{ translate("Register") }}</a
                                    >
                                </div>
                                <div class="w-100">
                                    <a
                                        class="d-inline-block text-dark text-decoration-underline"
                                        href="/forgot-password"
                                        >{{
                                            translate("Forgot your password?")
                                        }}</a
                                    >
                                </div>
                            </div>

                            <button
                                type="submit"
                                class="btn dm-btn-brand font-weight-bolder ml-4 dm-login-button"
                                :disabled="submitting"
                                v-html="logInButtonHtml"
                            ></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { validationPopupsMixin } from "@/mixins/validationPopupsMixin.js";

export default {
    mixins: [validationPopupsMixin],

    props: ["redirect_to_wizard"], // redirect_to_wizard, if present, will redirect the user after login to the wizard determined by the landing_page_id

    data() {
        return {
            email: "",
            password: "",
            remember: false,
            landing_page_id: typeof landingPageId !== 'undefined' ? landingPageId : null,
            entry_point_id: typeof entryPointId !== 'undefined' ? entryPointId : null,

            validatedForm: null,
            parsleyOptions: {
                errorClass: "is-invalid",
                successClass: "is-valid",
            },
            submitting: false,

            errors: "",
        };
    },

    computed: {
        logInButtonHtml() {
            return this.submitting
                ? this.translate("Logging in") +
                      '... <span class="spinner spinner-track spinner-info spinner-lg ml-4 mr-4"></span>'
                : this.translate("Login");
        },

        loginData() {
            let loginData = {
                _token: document.head.querySelector('meta[name="csrf-token"]')
                    .content,
                email: this.email,
                password: this.password,
                remember: false,
            };

            if (this.entry_point_id)
                loginData.entry_point_id = this.entry_point_id;

            if (this.redirect_to_wizard)
                loginData.landing_page_id = this.landing_page_id;

            return loginData;
        },
    },

    methods: {
        validateAndSubmit() {
            this.validatedForm.validate();
            if (!this.validatedForm.isValid()) {
                return;
            }

            this.submitForm();
        },

        submitForm() {
            this.submitting = true;
            this.errors = [];

            var self = this;
            axios
                .post("/login-api", this.loginData)
                .then(function (response) {
                    self.submitting = false;
                    if (response.data && response.data.show_otp_confirmation) {
                        self.$emit("showOtpConfirmation", self.email);
                        return;
                    }

                    if (response.data.redirect_to)
                        window.location.href = response.data.redirect_to;
                })
                .catch(function (error) {
                    self.submitting = false;
                    self.errors = error.response.data.message;
                });
        },
    },

    mounted() {
        this.validatedForm = jQuery("#dm-log-in-form").parsley(
            this.parsleyOptions,
        );
    },
};
</script>
